import { render, staticRenderFns } from "./UbrAccount.vue?vue&type=template&id=56954f0d&scoped=true"
import script from "./UbrAccount.vue?vue&type=script&lang=js"
export * from "./UbrAccount.vue?vue&type=script&lang=js"
import style0 from "./UbrAccount.vue?vue&type=style&index=0&id=56954f0d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56954f0d",
  null
  
)

export default component.exports